import { connect } from 'react-redux';
import SearchSiswa from '../../../views/Student/report/SearchSiswa.student.view';
import { getStudent } from '../../../states/thunks/student.thunk';


function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}

export default connect(null, mapDispatchToProps)(SearchSiswa);


